import { PRINT_SIZES } from '../contexts/PrintSelectionContext';
import { gbp, tierRangeLabel, unitPrice, type PricingData } from '../hooks/usePrintPricing';
import styles from './VolumeDiscountTable.module.css';

/**
 * Price per print at each volume tier, for every size with a price, with the
 * tier the basket is in now highlighted. Renders nothing without tiers.
 */
export function VolumeDiscountTable({ pricing, totalQuantity }: { pricing: PricingData; totalQuantity: number }) {
  const tiers = pricing.volume_discounts ?? [];
  if (tiers.length === 0) return null;
  const sizes = PRINT_SIZES.filter((s) => pricing.prices?.[s]?.gbp != null);

  return (
    <table className={styles.table}>
      <caption className={styles.caption}>Price per print — volume discounts applied automatically</caption>
      <thead>
        <tr>
          <th scope="col">Prints</th>
          {sizes.map((s) => (
            <th key={s} scope="col" className={styles.number}>
              {s.replace('x', '×')}
            </th>
          ))}
          <th scope="col" className={styles.number}>
            Discount
          </th>
        </tr>
      </thead>
      <tbody>
        {tiers.map((tier) => {
          const current = totalQuantity >= tier.min && (tier.max == null || totalQuantity <= tier.max);
          return (
            <tr
              key={`${tier.min}-${tier.max ?? 'plus'}`}
              className={current ? styles.current : undefined}
              aria-current={current ? 'true' : undefined}
            >
              <td>{tierRangeLabel(tier)}</td>
              {sizes.map((s) => {
                const unit = unitPrice(s, pricing, tier.percent);
                return (
                  <td key={s} className={styles.number}>
                    {unit != null ? gbp(unit) : '—'}
                  </td>
                );
              })}
              <td className={styles.number}>{tier.percent > 0 ? `${tier.percent}% off` : '—'}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
